import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BlockingOverlay from 'components/BlockingOverlay';
import { getOperatorIsLoggingIn } from 'lib/selectors/getOperatorIsLoggingIn';
import { getOperatorIsLoggingOut } from 'lib/selectors/getOperatorIsLoggingOut';
import { getLaborTicketActionLoading } from 'lib/selectors/getLaborTicketActionLoading';
import { getLaborTicketAction } from 'lib/selectors/getLaborTicketAction';
import {
  OPERATOR_AUTH_BUSY,
  resolveGlobalAuthBusyPhase,
} from 'lib/utils/operatorAuthBusy';

const OperatorAuthOverlay = () => {
  const { t } = useTranslation();
  const isLoggingIn = useSelector(getOperatorIsLoggingIn);
  const isLoggingOut = useSelector(getOperatorIsLoggingOut);
  const laborTicketActionLoading = useSelector(getLaborTicketActionLoading);
  const laborTicketAction = useSelector(getLaborTicketAction);

  const phase = resolveGlobalAuthBusyPhase({
    isLoggingIn,
    isLoggingOut,
    laborTicketActionLoading,
    laborTicketAction,
  });

  if (!phase) return null;

  const isSigningOut = phase === OPERATOR_AUTH_BUSY.SIGNING_OUT;

  return (
    <BlockingOverlay
      isVisible
      title={
        isSigningOut
          ? t('operatorAuth|signingOut|title')
          : t('operatorAuth|signingIn|title')
      }
      subtitle={
        isSigningOut
          ? t('operatorAuth|signingOut|subtitle')
          : t('operatorAuth|signingIn|subtitle')
      }
    />
  );
};

export default OperatorAuthOverlay;
